import "../assets/index-00012a4c.css";
import { A as e } from "../chunks/actionText-60ff01d1.mjs";
import { n as s } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const a = {
  name: "NcActionText",
  mixins: [e],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  }
};
var c = function() {
  var t = this, n = t._self._c;
  return n("li", { staticClass: "action", attrs: { role: t.isInSemanticMenu && "presentation" } }, [n("span", { staticClass: "action-text", on: { click: t.onClick } }, [t._t("icon", function() {
    return [t.icon !== "" ? n("span", { staticClass: "action-text__icon", class: [t.isIconUrl ? "action-text__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? `url(${t.icon})` : null }, attrs: { "aria-hidden": "true" } }) : t._e()];
  }), t.name ? n("span", { staticClass: "action-text__longtext-wrapper" }, [n("strong", { staticClass: "action-text__name" }, [t._v(" " + t._s(t.name) + " ")]), n("br"), n("span", { staticClass: "action-text__longtext", domProps: { textContent: t._s(t.text) } })]) : t.isLongText ? n("span", { staticClass: "action-text__longtext", domProps: { textContent: t._s(t.text) } }) : n("span", { staticClass: "action-text__text" }, [t._v(t._s(t.text))]), t._e()], 2)]);
}, i = [], o = /* @__PURE__ */ s(
  a,
  c,
  i,
  !1,
  null,
  "34d9a49c",
  null,
  null
);
const m = o.exports;
export {
  m as default
};
